{
  "titles": {
    "files": "Bestanden"
  },

  "messages": {
    "noFiles": "Geen bestanden beschikbaar"
  }
}
